"use client"

import ProductLabelSkeleton from "@/components/common/ProductLabel/index.skeleton"
import ProductSizeButtonSkeleton from "@/components/common/ProductSizeButton/index.skeleton"
import { Col, Row } from "antd"

const ProductSizesSkeleton = () => {

  return (
    <>
      <Row>
        <ProductLabelSkeleton />
      </Row>
      <Row gutter={[10, 10]}>
        {Array(7).fill(null).map((_, idx) => {
          return (
            <Col key={idx}>
              <ProductSizeButtonSkeleton />
            </Col>
          )
        })}
      </Row>
    </>
  )
}

export default ProductSizesSkeleton